import { ServiceRequest } from "../utils/service-request"
import {
    MOTOR_CADASTRO_PATH,
    MOTOR_CADASTRO_TEMPORARIO_PATH
} from "../utils/api-routes"

class MotorConversibilidadeService {
    constructor() {
        this.request = new ServiceRequest()
    }

    // Temporario
    async getTemporarioConversibilidade(id) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_TEMPORARIO_PATH}/${safeId}/conversibilidade`
        return this.request.get(path)
    }

    async createCadastroTemporarioConversibilidade(id, payload) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_TEMPORARIO_PATH}/${safeId}/conversibilidade`
        return this.request.post(path, payload)
    }

    async deleteCadastroTemporarioConversibilidade(id) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_TEMPORARIO_PATH}/${safeId}/conversibilidade`
        return this.request.delete(path)
    }

    // Producao
    async getConversibilidade(id) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/conversibilidade`
        return this.request.get(path)
    }

    async createCadastroConversibilidade(id, payload) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/conversibilidade`
        return this.request.post(path, payload)
    }

    async updateCadastroConversibilidade(id, payload) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/conversibilidade`
        return this.request.put(path, payload)
    }

    async deleteCadastroConversibilidade(id) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/conversibilidade`
        return this.request.delete(path)
    }
}

export default MotorConversibilidadeService